if (!customElements.get('size-chart-modal')) {
  class SizeChartModal extends HTMLElement {
    constructor() {
      super()
      this.content = this.querySelector('.size-chart-modal__content')
    }

    connectedCallback() {
      this.addEventListener('click', this.close.bind(this))
      this.content.addEventListener('click', (e) => e.stopPropagation())
      this.addEventListener('change', this.handleChange.bind(this))
      this.querySelector('.js-close').addEventListener('click', this.close.bind(this))
    }

    open() {
      this.classList.add('is-open')
    }

    close() {
      this.classList.remove('is-open')
    }

    handleChange(e) {
      const unitSystem = e.target.value
      const imageContainers = this.content.querySelectorAll('[data-unit-system]')
      imageContainers.forEach((container) => {
        if (container.dataset.unitSystem === unitSystem) {
          container.style.display = 'block'
        } else {
          container.style.display = 'none'
        }
      })
    }
  }
  customElements.define('size-chart-modal', SizeChartModal)
}
